import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Servicio que lleva un control para el muestreo de los loading: tanto parciales como globales
 */
@Injectable()
export class LoadingService {
  /**
   * Variables para saber si hay llamadas restconn activas;
   */
  private totalLoadings = [];
  private _hasLoadings = new BehaviorSubject<Array<any>>(this.totalLoadings);
  hasLoadings = this._hasLoadings.asObservable();
  /**
   * Colección de ids que invocan a las cargas parciales
   */
  public partialLoadings: string[];
  /**
   * Coleccion de ids que invocan a fullPage Loading
   */
  public fullPageLoading: string[];
  constructor() {
    this.partialLoadings = [];
    this.fullPageLoading = [];
  }
  /**
   * Función que añade un elemento que reliza un bloqueo total de página
   * @param name id (puede ser el del restConn) para instanciar el bloqueo de pagina
   */
  public fullPageOpen(name) {
    this.fullPageClose(name);
    this.fullPageLoading.push(name);
    this.setHasLoadings(name);
  }

  /**
   * Limpiar todos los loading de fullPage
   */
  cleanLocks() {
    const elementsToDelete = Object.assign([], this.fullPageLoading);
    for (const loadingKey of elementsToDelete) {
      this.fullPageClose(loadingKey);
    }
  }

  cleanPartials() {
    const elementsToDelete = Object.assign([], this.partialLoadings);
    for (const loadingKey of elementsToDelete) {
      this.partialLoadingClose(loadingKey);
    }
  }

  cleanAllLoadings() {
    this.cleanLocks();
    this.cleanPartials();
  }

  /**
   * Función que te dice si tiene un rest activo en base a su id
   */
  hasTotalLoading(name: string) {
    return this.totalLoadings.indexOf(name) >= 0;
  }

  /**
   * Retira uno de los elementos que hace un bloqueo total de página
   * @param name id (puede ser el del restConn) para desinstanciar el bloqueo de pagina
   */
  public fullPageClose(name) {
    while (this.fullPageLoading.indexOf(name) !== -1) {
      const positionRef = this.fullPageLoading.indexOf(name);
      if (positionRef !== -1) {
        this.fullPageLoading.splice(positionRef, 1);
        this.deleteHasLoadings(name);
      }
    }
  }
  /**
   * abre una carga parcial de una página
   * @param idRef  id (puede ser el del restConn) para instanciar el loading de ese elemento
   */
  public partialLoadingOpen(idRef) {
    this.partialLoadingClose(idRef);
    this.partialLoadings.push(idRef);
    this.setHasLoadings(name);
  }

  /**
   * Cierra una carga parcial de una página
   * @param idRef  id (puede ser el del restConn) para desinstanciar el loading de ese elemento
   */
  public partialLoadingClose(idRef) {
    const positionRef = this.partialLoadings.indexOf(idRef);
    if (positionRef !== -1) {
      this.partialLoadings.splice(positionRef, 1);
      this.deleteHasLoadings(idRef);
    }
  }

  /**
   * Indica si hay llamadas restconn
   * @param id Id restconn
   */
  public setHasLoadings(id) {
    if (id !== '') {
      this.deleteHasLoadings(id);
      const positionRef = this.totalLoadings.indexOf(id);
      if (positionRef === -1) {
        this.totalLoadings.push(id);
        this._hasLoadings.next(this.totalLoadings);
      }
    }
  }

  /**
   * Elimina un id del total de llamadas restconn
   * @param id Id restconn
   */
  public deleteHasLoadings(id) {
    const positionRef = this.totalLoadings.indexOf(id);
    if (positionRef !== -1) {
      this.totalLoadings.splice(positionRef, 1);
      setTimeout(() => {
        this._hasLoadings.next(this.totalLoadings);
      }, 200);
    }
  }

  /**
   * Elimina un id del total de llamadas restconn
   */
  public deleteAllHasLoadings() {
    this.totalLoadings = [];
    this._hasLoadings.next(this.totalLoadings);
  }
}
